<template>
  <div>{{ datares }}</div>
</template>
<script>
export default {
  name: 'Ready',
  data() {
    return {
      datares: this.$route.name
    }
  },
  created() {
    this.datares = this.$route.name
  }
}
</script>
